import { render, staticRenderFns } from "./CopyrightTerms.vue?vue&type=template&id=0f3085d6&scoped=true&"
import script from "./CopyrightTerms.vue?vue&type=script&lang=js&"
export * from "./CopyrightTerms.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightTerms.vue?vue&type=style&index=0&id=0f3085d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3085d6",
  null
  
)

export default component.exports